module.exports = __webpack_public_path__ + "static/media/FollowIcon.643fd752.svg";